import script from "./apprehension.vue?vue&type=script&setup=true&lang=js"
export * from "./apprehension.vue?vue&type=script&setup=true&lang=js"

import "./apprehension.vue?vue&type=style&index=0&id=41c216d4&scoped=true&lang=css"

import exportComponent from "/home/staging-tcms.qpax-tcms.net/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41c216d4"]])

export default __exports__